import React from 'react';

const itemRenderer = ({ item, timelineContext, itemContext, getItemProps }) => {
  console.log('The Items', item);
  console.log('The ItemContext', itemContext);
  let backgroundColor = '';
  switch (item.type || item.status) {
    case 6020: //vacation
      backgroundColor = '#00bb87';
      break;
    case 6556: //unpaid
      backgroundColor = '#f2b827';
      break;
    case 6022: //sick
      backgroundColor = '#3c130f';
      break;
    default:
      backgroundColor = '#232a32';
      break;
  }

  let opacity = '';
  switch (item.status) {
    case 'Pending':
      case 'Pending Cancellation': 
        opacity = '0.4';
    break;
    default: opacity = '1'; break;
  }
  if(item.status === 'Denied' || item.status === 'Cancelled')
    return null;
  return (
    <div
      {...getItemProps({
        style: {
          backgroundColor,
          background: backgroundColor,
          opacity,
          color: 'white',
          fontSize: '12px',
          border: '1px solid rgb(26, 111, 179)',
          borderRadius: '8px',
        },
        // onMouseDown: () => {
        //   console.log('on item click', item);
        //   return false;
        // },
      })}
    >
      <div
        style={{
          height: itemContext.dimensions.height,
          width: '100%',
          overflow: 'hidden',
          paddingLeft: 3,
          textOverflow: 'ellipsis',
          textAlign: 'center',
          whiteSpace: 'nowrap',
        }}
      >
        {itemContext.title} ({item.totalHours} hrs)
      </div>
    </div>
  );
};

export default itemRenderer;
